import React from "react";
import Modal from "react-modal";
import { useLoading } from "../../services/LoadingContext";
import NotificationsMenu from "../../pages/account/NotificationsMenu";
import "./NotificationsModal.scss";

interface props {
  isOpen: boolean;
  onClose: () => void;
}

const NotificationsModal: React.FC<props> = ({ isOpen, onClose }) => {
  const { setIsLoading } = useLoading();
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          background: "transparent",
          border: "none",
          zIndex: 5,
          padding: 0,
        },
      }}
    >
      <NotificationsMenu setIsLoading={setIsLoading} />
    </Modal>
  );
};

export default NotificationsModal;
